import { render } from "./PackageAdvantages.vue?vue&type=template&id=a9a818fc&scoped=true"
import script from "./PackageAdvantages.vue?vue&type=script&lang=js"
export * from "./PackageAdvantages.vue?vue&type=script&lang=js"

import "./PackageAdvantages.vue?vue&type=style&index=0&id=a9a818fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a818fc"]])

export default __exports__